// Section 24.12 migration 0001 (format 1 -> 2): add `summary` so save lists can show turn,
// season, population and outcome without replaying. Frozen after merge: it embeds the format-1
// calendar (four seasons from Spring) instead of reading the current config.
import type { RawEnvelope } from '../envelope';
import type { Migration } from './types';

const V1_SEASONS = ['spring', 'summer', 'autumn', 'winter'] as const;

interface V1Snapshot {
  turn?: unknown;
  year?: unknown;
  season?: unknown;
  people?: unknown;
  outcome?: { kind?: unknown } | null;
}

function summaryOf(env: RawEnvelope): Record<string, unknown> {
  const snapshot = env.snapshot as V1Snapshot | null | undefined;
  const options = env.options as { ironman?: unknown } | undefined;
  const ironman = options?.ironman === true;
  if (snapshot !== null && snapshot !== undefined && typeof snapshot === 'object') {
    const kind = snapshot.outcome?.kind;
    return {
      turn: snapshot.turn,
      year: snapshot.year,
      season: snapshot.season,
      population:
        snapshot.people !== null && typeof snapshot.people === 'object'
          ? Object.keys(snapshot.people).length
          : null,
      outcome: kind === 'won' || kind === 'lost' ? kind : null,
      ironman,
    };
  }
  const turn = Array.isArray(env.decisionLog) ? env.decisionLog.length : 0;
  return {
    turn,
    year: Math.floor(turn / V1_SEASONS.length) + 1,
    season: V1_SEASONS[turn % V1_SEASONS.length],
    population: null,
    outcome: null,
    ironman,
  };
}

export const addSummary: Migration = {
  from: 1,
  to: 2,
  description: 'add summary (turn, season, population, outcome) for save lists',
  migrate: (env) => ({ ...env, formatVersion: 2, summary: summaryOf(env) }),
};
